import { render, staticRenderFns } from "./StudentScheduleHistory.vue?vue&type=template&id=38711ca0&scoped=true"
import script from "./StudentScheduleHistory.vue?vue&type=script&lang=js"
export * from "./StudentScheduleHistory.vue?vue&type=script&lang=js"
import style0 from "./StudentScheduleHistory.vue?vue&type=style&index=0&id=38711ca0&prod&scoped=true&lang=css"
import style1 from "./StudentScheduleHistory.vue?vue&type=style&index=1&id=38711ca0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38711ca0",
  null
  
)

export default component.exports